import React from "react";
import { useQuery } from "@apollo/client";
import PropTypes from "prop-types";
import reactStringReplace from "react-string-replace";
import { v4 as uuidv4 } from "uuid";

import { GET_TERMS_AND_CONDITIONS } from "../../Graphql/queries/queryGetTermsAndConditions";
import { LoadingScreen } from "../../components/StatusScreens/LoadingScreen";
import { useToastError } from "../../Hooks/useToastError";
import { useToastInfo } from "../../Hooks/useToastInfo";
import PrimaryNormal from "../../components/buttons/PrimaryNormal";

import { ContainerButtons, TextDescription, Title, Content, Modal } from "./styles";
import { Variables } from "../../styles/Variables";

const ModalTermsConditions = ({ setModalVisible, modalVisible, press, setTerms, idTermsAndConditions }) => {
  const toastInfo = useToastInfo();

  const { error, data, loading } = useQuery(GET_TERMS_AND_CONDITIONS, {
    variables: {
      getTermAndConditionsId: idTermsAndConditions,
    },
    onError: (err) => console.error(err),
  });

  useToastError(error);

  function ReplaceText(content) {
    const bold = /\*\*(.*?)\*\*/gm;
    const urlExp = /\[\[(.*?)\[\[/gm;

    const texts = reactStringReplace(content, bold, (match) => <b key={`bold-${uuidv4()}`}>{match}</b>);

    return texts.map((text) => {
      if (typeof text === "string") {
        const TF = reactStringReplace(text, "$", () => (
          <div key={uuidv4()}>
            <br />
          </div>
        ));
        return reactStringReplace(TF, urlExp, (match) => {
          const url = `https://${match}`;
          return (
            <a href={url} key={uuidv4()}>
              {match}
            </a>
          );
        });
      } else {
        return text;
      }
    });
  }

  if (loading) {
    return <LoadingScreen />;
  }

  if (error || !data?.getTermAndConditions) {
    console.error("Error al cargar los términos y condiciones.");
    return <div></div>;
  }

  const getTerms = data.getTermAndConditions;

  // Mover la asignación de `setTerms` dentro de una verificación para evitar problemas
  if (getTerms?.id) {
    setTerms(getTerms.id);
  }

  return modalVisible ? (
    <Modal onClick={() => setModalVisible(false)}>
      <Content onClick={(event) => event.stopPropagation()}>
        <Title>{getTerms.title}</Title>
        <TextDescription>{ReplaceText(getTerms.content)}</TextDescription>
        <ContainerButtons>
          <PrimaryNormal
            title="Acepto"
            orange={true}
            onClick={press}
            style={{ height: 30, marginTop: 10, marginBottom: 10 }}
          />
          <PrimaryNormal
            title="No acepto"
            onClick={() => {
              setModalVisible(false);
              toastInfo("Ups, para guardar la información debes aceptar los términos.");
            }}
            style={{ height: 30, marginTop: 10, marginBottom: 10, backgroundColor: Variables.colorOrange }}
          />
        </ContainerButtons>
      </Content>
    </Modal>
  ) : (
    <div />
  );
};

ModalTermsConditions.propTypes = {
  setModalVisible: PropTypes.func,
  modalVisible: PropTypes.bool,
  press: PropTypes.func,
  setTerms: PropTypes.func,
  idTermsAndConditions: PropTypes.string,
};

export default ModalTermsConditions;
